import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { reduxForm, stopAsyncValidation } from 'redux-form/immutable'
import moment from 'moment'

import { addReducer, removeReducer } from 'state/reducers'
import { addSaga, removeSaga } from 'state/sagas'

import api from 'api'

import Page from 'layouts/Page'
import Box, { BoxSection } from 'layouts/Box'
import { FormChoiceGroup } from 'layouts/Form'
import { ActivityScheduleFormReadOnly } from 'forms/Activity'
import UserHead from 'components/UserHead'
import UserSkills from 'components/UserSkills'
import Search from 'components/Search'
import Spinner from 'components/Spinner'
// import Switch from 'components/Switch'
import Choice from 'components/Choice'
import Button from 'components/Button'
import Link from 'components/Link'
import SearchResult from 'components/SearchResult'
import Lightbox from 'components/Lightbox'
import GoogleMap, { Marker, InfoWindow } from 'components/GoogleMap'
// import { Tab, Tabs, TabList, TabPanel } from 'components/Tabs'
import VideoPlayer from 'components/VideoPlayer'

import SvgBluePin from 'assets/svgs/pin.svg'
import SvgOrangePin from 'assets/svgs/pin-orange.svg'
import SvgSearch from 'components/Svg/SvgSearch'

import { PARENT_SIGNUP } from 'views/Signup/constants'
import { NAME as ROUTE_LOGIN } from 'views/Login/constants'
import { NAME as ROUTE_PROFILE } from 'views/Profile/constants'
import { reverse } from 'utilities/routes'

import { NAME } from './constants'
import actions from './actions'
import reducer from './reducer'
import saga from './sagas'
import selector from './selectors'

import styles from './styles.css'

let ActivityForm = ({
  asyncValidating,
  handleSubmit,
  onSubmit,
  schedule,
  scheduleBooked,
}) => (
  <form
    onSubmit={handleSubmit(() => {
      const initMonth = (schedule || []).find(s =>
        moment(s.start_dt).isAfter(new Date()),
      )
      onSubmit({ month: initMonth ? new Date(initMonth.start_dt) : null })
    })}
  >
    <ActivityScheduleFormReadOnly
      button={
        <Button loading={asyncValidating} size="full" rounded>
          Planera aktivitet
        </Button>
      }
      schedule={schedule}
      scheduleBooked={scheduleBooked}
      onSubmit={onSubmit}
    />
  </form>
)

ActivityForm.propTypes = {
  asyncValidating: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  schedule: PropTypes.array,
  scheduleBooked: PropTypes.array,
}

ActivityForm.defaultProps = {
  asyncValidating: false,
  schedule: [],
  scheduleBooked: [],
}

ActivityForm = reduxForm({
  form: NAME,
  onChange: (values, dispatch) => {
    dispatch(stopAsyncValidation(NAME, { clear: true }))
  },
})(ActivityForm)

class FindActivityPage extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    location: PropTypes.shape({
      query: PropTypes.shape({
        tag: PropTypes.string,
      }),
    }),
    employees: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        picture: PropTypes.string.isRequired,
      }),
    ),
    activities: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
      }),
    ).isRequired,
    schools: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
      }),
    ).isRequired,
    loading: PropTypes.bool.isRequired,
    joining: PropTypes.bool,
    lightboxActive: PropTypes.bool,
    details: PropTypes.object,
    markerDetails: PropTypes.object,
    loadingMarkerDetails: PropTypes.string,
    asyncValidating: PropTypes.bool,
    account: PropTypes.oneOfType([
      PropTypes.bool.isRequired,
      PropTypes.object.isRequired,
    ]),
    userChildren: PropTypes.array,
    userActivities: PropTypes.array,
  }

  static defaultProps = {
    employees: null,
    asyncValidating: false,
    details: undefined,
    markerDetails: undefined,
    loadingMarkerDetails: undefined,
    joining: false,
    lightboxActive: false,
    location: {
      query: {
        tag: undefined,
      },
    },
    account: false,
    userChildren: [],
    userActivities: [],
  }

  state = {
    criteria: [],
    // filterLeaders: false,
  }

  componentDidMount() {
    addReducer(NAME, reducer)
    addSaga(NAME, saga)
    this.addInitialCriteria()
  }

  componentWillUnmount() {
    const { dispatch } = this.props
    dispatch(actions.set({ lightboxActive: false }))
    removeReducer(NAME)
    removeSaga(NAME)
  }

  getDisabledContent(message) {
    const { account, userChildren } = this.props

    const userRole = account && account.get('signupFlow')
    const isLeader = userRole === 'leader'

    return !account ? (
      <p>
        <Link className={styles.orangeLink} href={reverse(ROUTE_LOGIN)}>
          Logga in
        </Link>{' '}
        eller <Link href={reverse(PARENT_SIGNUP)}>registrera dig</Link>
        {` ${message}`}
      </p>
    ) : !account.has('profileId') ? (
      <p>
        Du behöver fylla i din{' '}
        <Link href={reverse(ROUTE_PROFILE)} className={styles.link}>
          profil
        </Link>{' '}
        {message}
      </p>
    ) : userChildren.length === 0 && !isLeader ? (
      <p>
        Du behöver{' '}
        <Link href={reverse(ROUTE_PROFILE)} className={styles.link}>
          registrera ditt barn
        </Link>{' '}
        {message}
      </p>
    ) : null
  }

  async addInitialCriteria() {
    const tagName = this.props.location.query.tag

    if (tagName == null) {
      return
    }

    const tags = await api.search.suggest(tagName)
    // Only use the first result, because some tag names are prefixes of
    // others, such as “Musik” and “Musikskapande”. The results are sorted
    // by relevance.
    this.updateCriteria(tags.slice(0, 1))
  }

  updateCriteria(criteria) {
    this.setState({ criteria })
    this.props.dispatch(actions.search(criteria))
  }

  showDetails(object) {
    this.props.dispatch(actions.details(object))
    this.props.dispatch(actions.set({ lightboxActive: true }))

    this.setState({
      fullDetailsVisible: false,
    })
  }

  renderEmployeeDetails() {
    const { fullDetailsVisible } = this.state
    const { details, dispatch } = this.props
    const skills = {
      driver: details.has_drivers_license,
      cpr: details.has_cpr_certification,
    }
    const disabledContent = this.getDisabledContent(
      'för att boka en aktivitet.',
    )
    return (
      <Box className={styles.biography} shadow>
        <BoxSection className={styles.biographyHead}>
          <UserHead
            className={styles.biographyWidth}
            image={{
              src: details.picture && details.picture.url,
              alt: details.name,
            }}
            name={details.name}
            description={details.tagline}
          />
          <UserSkills {...skills} />
        </BoxSection>
        <BoxSection className={styles.biographyScroller}>
          {!fullDetailsVisible && (
            <BoxSection>
              <p>{details.bio}</p>
              <p>
                <a
                  className={styles.biographyExpand}
                  onClick={() =>
                    this.setState({
                      fullDetailsVisible: true,
                    })
                  }
                >
                  Läs mer
                </a>
              </p>

              <div>
                <strong>Kunskapsområden</strong>
                <br />

                <FormChoiceGroup>
                  {details.interest_motivations.map(interest => (
                    <Choice
                      className={styles.disabled}
                      key={interest.topic.id}
                      type="checkbox"
                      appearance="button"
                      label={interest.topic.name}
                    />
                  ))}
                </FormChoiceGroup>
              </div>
            </BoxSection>
          )}

          {fullDetailsVisible && (
            <BoxSection>
              <p>{details.bio}</p>

              {details.interest_motivations.map(interest => (
                <p key={interest.topic.id}>
                  <b>{interest.topic.name}</b>
                  <br />
                  {interest.motivation}
                </p>
              ))}

              {details.presentation && (
                <VideoPlayer url={details.presentation.url} controls />
              )}

              {details.documents.length > 0 && (
                <div>
                  <strong>Intyg och dokumentation</strong>
                  <br />
                  {details.documents.map(doc => (
                    <a href={doc.url}>
                      {doc.name}
                      <br />
                    </a>
                  ))}
                </div>
              )}

              <div>
                <strong>Kunskapsområden</strong>
                <br />

                <FormChoiceGroup>
                  {details.interest_motivations.map(interest => (
                    <Choice
                      className={styles.disabled}
                      key={interest.topic.id}
                      type="checkbox"
                      appearance="button"
                      label={interest.topic.name}
                    />
                  ))}
                </FormChoiceGroup>
              </div>
            </BoxSection>
          )}

          <BoxSection
            className={styles.createActivity}
            disabled={disabledContent != null}
            disabledContent={disabledContent}
          >
            <ActivityForm
              onSubmit={values => {
                dispatch(
                  actions.createActivity({
                    ...values,
                    employee: {
                      ...details,
                      picture: details.picture && details.picture.url,
                    },
                  }),
                )
              }}
              schedule={details.availability_schedule}
              scheduleBooked={details.booked_schedule}
            />
          </BoxSection>
        </BoxSection>
      </Box>
    )
  }

  renderActivityDetails() {
    const { dispatch, details, joining, userActivities } = this.props
    const { employee } = details

    const disabledContent = this.getDisabledContent(
      'för att gå med i en grupp.',
    )

    const alreadyInGroup = userActivities.some(
      activity => activity.id === details.id,
    )

    const sections = [
      employee && (
        <BoxSection key="employee">
          <UserHead
            image={{
              src: employee.picture,
              alt: employee.name,
            }}
            name={employee.name}
            description={employee.bio}
          />
        </BoxSection>
      ),
      !disabledContent && (
        <BoxSection key="parent">
          {alreadyInGroup ? (
            <Button rounded disabled>
              Du är med i denna grupp
            </Button>
          ) : (
            <Button
              rounded
              loading={joining}
              onClick={() => dispatch(actions.joinActivity(details.id))}
            >
              Gå med i gruppen
            </Button>
          )}
        </BoxSection>
      ),
    ].filter(Boolean)

    return (
      <Box className={styles.biography} shadow>
        <BoxSection>
          <h3>{details.name}</h3>
        </BoxSection>
        {sections.length > 0 ? (
          sections
        ) : (
          <BoxSection>{disabledContent}</BoxSection>
        )}
      </Box>
    )
  }

  renderMap() {
    const {
      schools,
      markerDetails,
      loadingMarkerDetails,
      dispatch,
    } = this.props

    const bluePin = {
      url: SvgBluePin,
      size: { width: 31, height: 50 },
      scaledSize: { width: 31, height: 50 },
    }

    const orangePin = {
      url: SvgOrangePin,
      size: { width: 31, height: 50 },
      scaledSize: { width: 31, height: 50 },
    }

    return (
      <GoogleMap className={styles.map}>
        {schools.map(school => (
          <Marker
            defaultIcon={school.activity_count ? orangePin : bluePin}
            zIndex={school.activity_count ? 2 : 1}
            key={school.id}
            position={{
              lat: school.location.lat,
              lng: school.location.lon,
            }}
            onClick={() => {
              dispatch(actions.loadSchoolDetails(school.id))
            }}
          >
            {loadingMarkerDetails === school.id && (
              <InfoWindow>
                <Spinner width="45" height="45" />
              </InfoWindow>
            )}
            {markerDetails &&
              markerDetails.id === school.id && (
                <InfoWindow
                  onCloseClick={() => {
                    dispatch(actions.clearSchoolDetails())
                  }}
                >
                  <div className={styles.schoolDetails}>
                    <h1>
                      {markerDetails.name} <small>(Skola)</small>
                    </h1>
                    <small>
                      {markerDetails.street_address}, {markerDetails.zip_code},{' '}
                      {markerDetails.city}
                    </small>

                    {markerDetails.topics.length > 0 && (
                      <div>
                        <h2>Tillgängliga aktiviteter</h2>
                        <ul>
                          {markerDetails.topics.map(topic => (
                            <li key={topic.id}>{topic.name}</li>
                          ))}
                        </ul>
                      </div>
                    )}

                    {markerDetails.activities.length > 0 && (
                      <div>
                        <h2>Tillgängliga grupper</h2>
                        <ul>
                          {markerDetails.activities.map(activity => (
                            <li key={activity.id}>
                              <a
                                onClick={() => {
                                  this.showDetails({
                                    type: 'activity',
                                    ...activity,
                                  })
                                }}
                              >
                                {activity.name}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}

                    {markerDetails.employees.length > 0 && (
                      <div>
                        <h2>Tillgängliga ledare</h2>
                        <ul>
                          {markerDetails.employees.map(employee => (
                            <li key={employee.id}>
                              <a
                                onClick={() => {
                                  this.showDetails({
                                    type: 'employee',
                                    ...employee,
                                  })
                                }}
                              >
                                {employee.name}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                </InfoWindow>
              )}
          </Marker>
        ))}
      </GoogleMap>
    )
  }

  /**
   * renderResults renders both Leaders and groups.
   * By request of Jonte we'll remove the groups tab from findActivity for the moment
   * It is commented out until we know for sure whether it should stay or not.
   */
  /*
    renderResults() {
        const { activities, details, lightboxActive } = this.props
        const { filterLeaders } = this.state
        return (
            <Tabs className={styles.tabs}>
                <TabList>
                    <Tab>Ledare</Tab>
                    <Tab>Grupper</Tab>
                </TabList>
                <TabPanel className={styles.tabsPanel}>
                    {this.renderLeaders()}
                </TabPanel>
                <TabPanel className={styles.tabsPanel}>
                    <div className={styles.filter}>
                        <Switch
                            type="checkbox"
                            label="Visa endast grupper utan ledare"
                            input={{
                                checked: filterLeaders,
                                onChange: e =>
                                    this.setState({
                                        filterLeaders: e.target.checked,
                                    }),
                            }}
                        />
                    </div>
                    <div className={styles.resultsWrapper}>
                        {activities.length === 0 && (
                            <div className={styles.noResults}>
                                <p>Hittade inga resultat.</p>
                            </div>
                        )}
                        <div className={styles.results}>
                            {activities
                                .filter(
                                    activity =>
                                        (filterLeaders &&
                                            !activity.employee_id) ||
                                        !filterLeaders,
                                )
                                .map(activity => (
                                    <SearchResult
                                        key={activity.id}
                                        href="http://"
                                        title={activity.name}
                                        description={
                                            !activity.employee_id &&
                                            'Ledare sökes'
                                        }
                                        tag="Grupp"
                                        selected={
                                            lightboxActive &&
                                            details &&
                                            details.id === activity.id
                                        }
                                        onClick={() =>
                                            this.showDetails({
                                                type: 'activity',
                                                ...activity,
                                            })
                                        }
                                    />
                                ))}
                        </div>
                    </div>
                </TabPanel>
            </Tabs>
        )
    }
    */

  renderLeaders() {
    const { details, /* account, */ employees, lightboxActive } = this.props

    return (
      <div className={styles.resultsWrapper}>
        {employees == null ? (
          <div className={styles.message}>
            <p>Laddar…</p>
          </div>
        ) : (
          employees.length === 0 && (
            <div className={styles.message}>
              <p>Hittade inga resultat.</p>
            </div>
          )
        )}

        <div className={styles.results}>
          <div>
            {employees &&
              employees.map(employee => (
                <SearchResult
                  key={employee.id}
                  href={employee.picture}
                  image={{
                    src: employee.picture,
                    alt: employee.name,
                  }}
                  title={employee.name}
                  description={employee.bio}
                  tag="Ledare"
                  selected={
                    lightboxActive && details && details.id === employee.id
                  }
                  onClick={() =>
                    this.showDetails({
                      type: 'employee',
                      ...employee,
                    })
                  }
                />
              ))}
          </div>
          {/*
                    This code renders the "create activity" button.
                    It is commented out until we know for sure if it should stay or not.

                    <div className={styles.resultsFooter}>
                        <h4>Hittar du ingen ledare som passar?</h4>
                        <p>
                            Skapa en aktivitet för att visa att du är
                            intresserad av att hitta en ledare. Nya duktiga
                            ledare rekryteras löpande. Om du lagt upp en
                            förfrågan så ökar chansen att du snabbt hittar just
                            den bästa ledaren för din grupp.
                        </p>
                        <Button
                            size="full"
                            rounded
                            onClick={() => {
                                if (account) {
                                    this.props.dispatch(
                                        actions.createEmptyActivity(),
                                    )
                                } else {
                                    this.props.dispatch(
                                        reverse(ROUTE_LOGIN, {
                                            query: {
                                                message: 'activity',
                                            },
                                        }),
                                    )
                                }
                            }}
                            className={styles.resultsFooterAction}
                        >
                            Skapa din aktivitet
                        </Button>
                    </div>
                    */}
        </div>
      </div>
    )
  }

  renderPopup() {
    const { details } = this.props
    if (!details) {
      return null
    }
    if (details.type === 'employee') {
      return this.renderEmployeeDetails()
    } else if (details.type === 'activity') {
      return this.renderActivityDetails()
    }
    return null
  }

  render() {
    const { dispatch, lightboxActive } = this.props
    const { criteria } = this.state

    return (
      <Page className={styles.root} title="Hitta grupp">
        <form className={styles.search}>
          <SvgSearch className={styles.searchIcon} width="20" height="19.45" />
          <Search
            className={styles.searchInput}
            suggestions={async input => api.search.suggest(input)}
            placeholder="Skriv in den aktivitet/det intresse du letar efter"
            onChange={criteria => this.updateCriteria(criteria)}
            value={criteria}
            keyFunc={x => x.id}
            autofocus
          />
        </form>

        <div className={styles.main}>
          <div className={styles.browser}>
            {/* {this.renderResults()} */}
            {this.renderLeaders()}
          </div>

          <div className={styles.mapContainer}>
            {this.renderMap()}

            <Lightbox
              className={styles.lightbox}
              active={lightboxActive}
              backdrop
              onClose={() => dispatch(actions.set({ lightboxActive: false }))}
            >
              {this.renderPopup()}
            </Lightbox>
          </div>
        </div>
      </Page>
    )
  }
}

export default connect(selector)(FindActivityPage)



// WEBPACK FOOTER //
// ../source/views/FindActivity/index.js